import SelectWrapper from "@components/Select";
import {
  useLoadAvailableDistrictForUserQuery,
  useLoadAvailableVDCForUserMutation,
  useLoadPublicOfficeListMutation,
} from "@features/publicPage/homepage/api";
import {
  makeSelectDistrictOptions,
  makeSelectVdcOptions,
  makeSelectDistrictOptionsNorm,
  makeSelectVdcOptionsNorm,
} from "@features/publicPage/homepage/selectors";
import React from "react";
import { useState } from "react";
import { PiSpinnerBold } from "react-icons/pi";
import { RiMapPin2Fill } from "react-icons/ri";
import { useSelector } from "react-redux";

const NearestRetailer = () => {
  const [selectedLocations, setSelectedLocations] = useState({
    district: null,
    vdc: null,
  });

  // load available address;
  const { isLoading: districtLoading } = useLoadAvailableDistrictForUserQuery();
  // load availabe vdcs;
  const [loadVdcs, { isLoading: vdcLoading }] =
    useLoadAvailableVDCForUserMutation();
  // load retailers
  const [loadRetailers, { isLoading: retailerLoading, data: retailersData }] =
    useLoadPublicOfficeListMutation();

  const districtOptions = useSelector(makeSelectDistrictOptions);
  const districtOptionsNorm = useSelector(makeSelectDistrictOptionsNorm);
  const vdcOptions = useSelector(makeSelectVdcOptions);
  const vdcOptionsNorm = useSelector(makeSelectVdcOptionsNorm);

  const handleDropdown = (key) => (e) => {
    setSelectedLocations((prev) => ({
      ...prev,
      [key]: e.value,
    }));

    switch (key) {
      case "district":
        loadVdcs(e.value);
        break;
      case "vdc":
        loadRetailers(e.value);
        break;
    }
  };

  const returnRetailers = () => {
    if (selectedLocations?.vdc) {
      return (
        <>
          {retailerLoading ? (
            <div className='text-sm text-center mt-6 flex items-center gap-1 justify-center'>
              <PiSpinnerBold className='animate-spin' size='18' />
              Loading retailers near you...
            </div>
          ) : (
            <div className='text-sm'>
              <div className='grid grid-cols-2 gap-4 border-b border-gray-300 border-l border-r border-t font-semibold'>
                <div className='border-r border-gray-300 p-2 pl-3'>
                  Store Name
                </div>
                <div className='py-2'>Contact Number</div>
              </div>
              {retailersData?.data?.length > 0 ? (
                <>
                  {retailersData?.data?.map((each) => (
                    <div
                      key={each._id}
                      className='grid grid-cols-2 gap-4 border-l border-b border-r border-gray-300'
                    >
                      <div className='border-r flex gap-2 items-center border-gray-300 p-2 pl-3'>
                        {each.map_location ? (
                          <a
                            href={each.map_location}
                            target='_blank'
                            className='text-blue-500 hover:text-blue-900'
                          >
                            {each.name}
                          </a>
                        ) : (
                          <>{each.name}</>
                        )}
                        {each.map_location && (
                          <a href={each.map_location} target='_blank'>
                            <RiMapPin2Fill className='text-blue-500 hover:text-blue-900' />
                          </a>
                        )}
                      </div>
                      <div className='py-2'>{each.phone}</div>
                    </div>
                  ))}
                </>
              ) : (
                <div className='p-2 border-l border-b border-r border-gray-300 text-center'>
                  Store not availabe at this location. Try again with another
                  location.
                </div>
              )}
            </div>
          )}
        </>
      );
    } else {
      return (
        <div className='text-sm'>
          Select both locations to find the retailers near you.
        </div>
      );
    }
  };

  return (
    <div className='p-5'>
      <div className='grid grid-cols-1 lg:grid-cols-2 gap-2 mb-4'>
        <SelectWrapper
          options={districtOptions}
          divclassname='w-full'
          label='Select City'
          onChange={handleDropdown("district")}
          value={districtOptionsNorm[selectedLocations?.district] || ""}
          placeholder={
            districtLoading ? "Loading City Options..." : "Select..."
          }
        />
        <SelectWrapper
          options={vdcOptions}
          divclassname='w-full'
          label='Select Area'
          isDisabled={!selectedLocations?.district}
          onChange={handleDropdown("vdc")}
          value={vdcOptionsNorm[selectedLocations?.vdc] || ""}
          placeholder={
            vdcLoading
              ? "Loading Area..."
              : selectedLocations?.district
              ? "Select..."
              : "Please select city first."
          }
        />
      </div>
      {returnRetailers()}
    </div>
  );
};

export default NearestRetailer;
